// removed by extract-text-webpack-plugin
module.exports = {"SkillPanel":"SkillPanel__SkillPanel__kGQIv","SkillImportance":"SkillPanel__SkillImportance__3pepd","Description":"SkillPanel__Description__1DrGR","DescriptionEdit":"SkillPanel__DescriptionEdit__9SKbD","Buttons":"SkillPanel__Buttons__2T2WN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Builder/SkillPanel/SkillPanel.css
// module id = 150
// module chunks = 0